const ANALYSIS = {};

import vitalConversion from "@/module/util/vital-conversion";

export default function(events, content) {
  if (!Array.isArray(events)) return {};

  var analysis = {};
  var eventType = {};

  // Helpers for creating analysis objects
  var newAnalysis = (content, id) => ({
    id,
    event: [],
    first: null,
    last: null,
    content,
  });
  var addAnalysis = (analysis, event) => {
    analysis.event.push(event);
    if (
      analysis.first == null ||
      analysis.first.time > (event.time || event.created)
    )
      analysis.first = event;
    if (
      analysis.last == null ||
      analysis.last.time < (event.time || event.created)
    )
      analysis.last = event;
  };

  events.forEach((event) => {
    let typeId = (event.type || "").split(":");
    let type = typeId[0];

    if (
      type == "symptom" ||
      type == "vital" ||
      type == "article" ||
      type == "exercise"
    ) {
      let id = typeId[1];
      if (!eventType[type]) eventType[type] = {};
      if (!eventType[type][id])
        eventType[type][id] = newAnalysis(
          (type == "symptom" || type == "article" || type == "exercise") &&
            content[type]
            ? content[type][id]
            : null,
          id
        );

      if (type == "vital")
        addAnalysis(eventType[type][id], {
          type: event.type,
          value: event.value,
          unit: event.unit,
          time: event.time,
          created: event.created,
        });
      else addAnalysis(eventType[type][id], event);
    } else if (type.length > 0) {
      if (!eventType[type]) eventType[type] = newAnalysis();
      addAnalysis(eventType[type], event);
    }
  });

  Object.keys(ANALYSIS).forEach((type) => {
    if (eventType[type]) {
      if (type == "medication")
        analysis[type] = ANALYSIS[type](
          eventType.medication,
          eventType.compliance,
          eventType.dose
        );
      else if (type == "questionnaire" || type == "appointment")
        analysis[type] = ANALYSIS[type](eventType[type].event, content[type]);
      else analysis[type] = ANALYSIS[type](eventType[type], content[type]);
    }
  });

  // if (eventType.symptom)
  //     section.push(generateSymptom.call(this, patient, eventType.symptom))
  //
  // if (eventType.vital)
  //     section.push(generateVital.call(this, patient, eventType.vital))

  // if (eventType.food || eventType.water || eventType.excretion)
  // section.push(generateLifestyle.call(this, patient, eventType.food, eventType.water, eventType.excretion))

  return analysis;
}

ANALYSIS.medication = function(medication, compliance, dose) {
  compliance = compliance ? compliance.event : [];
  dose = dose ? dose.event : [];

  medication.event.forEach((med) => {
    med.compliance = compliance.filter((c) => c.medication == med.id);
    med.doses = dose.filter((d) => d.medication == med.id);
  });

  return {
    event: medication.event,
  };
};

ANALYSIS.article = function(article) {
  return article;
};

ANALYSIS.exercise = function(exercise) {
  return exercise;
};

// export default function(events, content) {
//     if (! Array.isArray(events))
//         return {}
//
//     var analysis = {}
//
//     Object.keys(ANALYSIS).forEach((type) => {
//         let typeEvents = events.filter((e) => (e.type && e.type.startsWith(type)))
//         console.log(type, typeEvents)
//         if (typeEvents.length > 0 && ANALYSIS[type])
//             analysis[type] = ANALYSIS[type](typeEvents, content[type])
//     })
//
//     return analysis
// }

ANALYSIS.appointment = function(appointments) {
  var upcoming = appointments.filter((a) => a.time + 86400000 < Date.now());

  if (upcoming.length > 0) return { event: upcoming };
  else return null;
};

ANALYSIS.vital = function(analysis) {
  var result = [];
  var eventType = {},
    totalVitals = 0,
    firstVital = null,
    lastVital = null;

  Object.keys(analysis).forEach((id) => {
    analysis[id].event.forEach((event) => {
      if (event.value != null) event.value = vitalConversion(event);
    });
  });

  return analysis;

  // var vitalTypes = Object.keys(vital).length

  // VITAL_ORDER.forEach((id) => {
  //     if (vital[id] == null) return
  //
  //     let name = id.split('_').map((n) => (
  //         n.substring(0, 1).toUpperCase() +
  //         n.substring(1))).join(' ')
  //
  //     let count = vital[id].event.length
  //     let firstDate = this.formatDate(vital[id].first.time, true)
  //     let lastDate = this.formatDate(vital[id].last.time, true)
  //
  //     result.push('They recorded ', name, ' ', count, ' time', count == 1 ? '' : 's')
  //
  //     if (id == 'blood_pressure') {
  //         let systolic = vital[id].event.map((e) => e.value[0])
  //         let diastolic = vital[id].event.map((e) => e.value[1])
  //         let minSystolic = Math.min(...systolic)
  //         let maxSystolic = Math.max(...systolic)
  //         let minDiastolic = Math.min(...diastolic)
  //         let maxDiastolic = Math.max(...diastolic)
  //
  //         result.push(' (systolic ')
  //         if (minSystolic == maxSystolic)
  //             result.push(minSystolic)
  //         else
  //             result.push(minSystolic, ' - ', maxSystolic)
  //         result.push(' mmHg, diastolic ')
  //         if (minDiastolic == maxDiastolic)
  //             result.push(minDiastolic)
  //         else
  //             result.push(minDiastolic, ' - ', maxDiastolic)
  //         result.push(' mmHg)')
  //     }
  //     else {
  //         let values = vital[id].event.map((e) => e.value)
  //         let minValue = Math.min(...values)
  //         let maxValue = Math.max(...values)
  //
  //         if (id == 'stress') {
  //             minValue = STRESS_VALUE[Math.round(minValue)]
  //             maxValue = STRESS_VALUE[Math.round(maxValue)]
  //             if (minValue == maxValue)
  //                 result.push(' (', minValue, ')')
  //             else
  //                 result.push(' (', minValue, ' to ', maxValue, ')')
  //         }
  //         else if (minValue == maxValue)
  //             result.push(' (', minValue.toFixed(1), VITAL_UNIT[id], ')')
  //         else
  //             result.push(' (min ', minValue.toFixed(1), VITAL_UNIT[id], ', max ', maxValue.toFixed(1), VITAL_UNIT[id], ')')
  //     }
  //     result.push('. ')
  // })
  //
  // return result.join('')
};

ANALYSIS.symptom = function(analysis, symptomContent) {
  Object.keys(analysis).forEach((symptomId) => {
    let symptomAnalysis = analysis[symptomId];

    symptomAnalysis.title = symptomAnalysis.content.title;
    symptomAnalysis.count = symptomAnalysis.event.length;

    // Create a mapping for each symptom question
    symptomAnalysis.question = {};
    symptomAnalysis.content.question.forEach((question) => {
      symptomAnalysis.question[question.question.toLowerCase()] = {
        id: question.id,
        question: question.question,
        title: question.title,
        answer: {},
      };
    });

    symptomAnalysis.event.forEach((symptom) => {
      if (Array.isArray(symptom.question)) {
        symptom.question.forEach((answer) => {
          let answerAnalysis =
            analysis[symptomId].question[answer.question.toLowerCase()];

          if (answerAnalysis) {
            if (Array.isArray(answer.option))
              answer.option.forEach((option) => {
                answerAnalysis.answer[option] =
                  (answerAnalysis.answer[option] || 0) + 1;
              });
            else if (answer.value)
              answerAnalysis.answer[answer.value] =
                (answerAnalysis.answer[answer.value] || 0) + 1;
          }
        });
      }
    });

    Object.keys(symptomAnalysis.question).forEach((questionId) => {
      let questionAnalysis = symptomAnalysis.question[questionId];
      let max = 0;

      Object.keys(questionAnalysis.answer).forEach((answer) => {
        if (questionAnalysis.answer[answer] > max)
          max = questionAnalysis.answer[answer];
      });

      Object.keys(questionAnalysis.answer).forEach((answer) => {
        if (questionAnalysis[answer] < Math.floor(max / 2))
          delete questionAnalysis.answer[answer];
      });
    });
  });

  // symptoms.forEach((symptom) => {
  //     let symptomId = symptom.type.split(':')[1]
  //     let content = symptomContent[symptomId]
  //     if (! content) {
  //         return
  //     }
  //
  //     // Initialize the symptom analysis
  //     if (! analysis[symptomId]) {
  //         analysis[symptomId] = {
  //             title: content.title,
  //             question: {},
  //             count: 0,
  //             content
  //         }
  //
  //         content.question.forEach((question) => {
  //             analysis[symptomId].question[question.question.toLowerCase()] = {
  //                 id: question.id,
  //                 question: question.question,
  //                 title: question.title,
  //                 answer: {}
  //             }
  //         })
  //     }
  //
  //     analysis[symptomId].count++
  //
  //     if (Array.isArray(symptom.question)) {
  //         symptom.question.forEach((answer) => {
  //             let answerAnalysis = analysis[symptomId].question[answer.question.toLowerCase()]
  //
  //             if (answerAnalysis) {
  //                 if (Array.isArray(answer.option))
  //                     answer.option.forEach((option) => {
  //                         answerAnalysis.answer[option] = (answerAnalysis.answer[option] || 0) + 1
  //                     })
  //                 else if (answer.value)
  //                     answerAnalysis.answer[answer.value] = (answerAnalysis.answer[answer.value] || 0) + 1
  //             }
  //         })
  //     }
  // })

  return analysis;
};

ANALYSIS.questionnaire = function(questionnaires, questionnaireContent) {
  var analysis = {};

  // Only show analysis for completed questionnaires
  questionnaires = questionnaires.filter((q) => q.completed);
  if (questionnaires.length == 0) return null;

  questionnaires
    .filter((q) => q.completed)
    .forEach((questionnaire) => {
      let questionnaireId = questionnaire.type.split(":")[1];
      let content = questionnaireContent[questionnaireId];
      if (!content) {
        return;
      }

      // Initialize the symptom analysis
      if (!analysis[questionnaireId]) {
        analysis[questionnaireId] = {
          title: content.title,
          question: {},
          count: 0,
          last: questionnaire.completed,
          content,
        };

        content.question.forEach((question) => {
          analysis[questionnaireId].question[question.id] = {
            id: question.id,
            question: question.question,
            title: question.title,
            answer: {},
          };
        });
      }

      analysis[questionnaireId].count++;
      if (analysis[questionnaireId].last < questionnaire.completed)
        analysis[questionnaireId].last = questionnaire.completed;

      if (Array.isArray(questionnaire.question)) {
        questionnaire.question.forEach((answer) => {
          if (answer) {
            let answerAnalysis = analysis[questionnaireId].question[answer.id];

            if (answerAnalysis) {
              let selected = displayAnswer(answer.answer);
              if (selected.length > 0)
                answerAnalysis.answer[questionnaire.completed] = selected;
            }
          }
        });
      }
    });

  return analysis;
};

function displayAnswer(answer) {
  if (Array.isArray(answer)) {
    return answer;
  }
  if (answer != null && typeof answer === "object") {
    var nullValue = false;
    Object.keys(answer).forEach((a) => {
      if (answer[a] == null) nullValue = true;
    });

    if (nullValue) return Object.keys(answer);
    else return Object.keys(answer).map((a) => answer[a]);
  }
  return [];
}
